import { subject } from "@casl/ability";
import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { getMediaGrupoByEmpresaId } from "@/modules/media-grupo/firestore";
import useUserStore from "@/modules/users/store";

type TGetMediaGrupoByEmpresaIdResponse = Awaited<ReturnType<typeof getMediaGrupoByEmpresaId>>;

const QUERY_KEY = "respostas";

/**
 * Get respostas query hook
 * @param root0 - root
 * @param root0.id - id
 * @param root0.empresaProjetoId - empresaProjetoId
 * @returns Respostas query hook
 */
function useMediaGrupoByEmpresaId({ id, empresaProjetoId }: { id: string; empresaProjetoId?: string | undefined }) {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresaId);
  const { idEmpresa } = useParams<{ idEmpresa: string }>();
  const empresaId = empresaProjetoId || activeEmpresaId;

  return useQuery<TGetMediaGrupoByEmpresaIdResponse, FirestoreError, TMediaGrupo[]>({
    queryKey: ["MediaGrupos", { id: empresaId }, QUERY_KEY, id, idEmpresa],
    queryFn() {
      if (!empresaId) {
        throw new Error("Empresa não selecionada");
      }

      if (!id) {
        throw new Error("Empresa não selecionada");
      }
      return getMediaGrupoByEmpresaId(empresaId, id, idEmpresa || "");
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }
      return dataResponse.docs.map((document_) => subject("TMediaGrupo", document_.data()));
    }
  });
}

export default useMediaGrupoByEmpresaId;
